import reducerMap from 'wanderu-ducks-account';

import UserAccounts from '../containers/UserAccounts/UserAccounts';

function onLoad(module, info, props, context) {
    context.store.inject(reducerMap);
}

export { onLoad };
export default UserAccounts;
